import { HeaderMenu } from "components";
import { ContentListSection, FilterList } from "./components";
import { useListFilter, useOriginalDataStore } from "./stores";
import { useListRegister, useShift } from "./hooks";
import { FormProvider, useForm } from "react-hook-form";
import { FormType } from "./schemas";
import { useEffect } from "react";
import { formatForm } from "./functions";

export default function ListShitSchedule() {

  // state
  const { filter, resetFilter } = useListFilter();
  const { setOriginalData } = useOriginalDataStore();

  useEffect(() => {
    resetFilter();

    // eslint-disable-next-line
  }, []);

  // hooks
  const { data, isLoading, refetch } = useListRegister(filter);
  const { data: shift } = useShift();

  // useForm
  const method = useForm<FormType>({
    defaultValues: {
      code: filter.shift_schedule_code,
      detail: []
    }
  })
  // effect
  useEffect(() => {
    if (!data) return;

    const formatted = formatForm(data, shift, filter.shift_schedule_id);
    const currentCode = method.getValues("code");

    method.reset({
      code: currentCode,
      detail: formatted
    });

    setOriginalData(formatted);

    // eslint-disable-next-line
  }, [data]);


  return (
    <section className="my-5">
      <HeaderMenu title="SHIFT SCHEDULE" />


      <section className="my-2">
        <FilterList />
      </section>

      <FormProvider {...method}>
        <ContentListSection
          isLoading={isLoading}
          refetch={refetch}
          data={data || []}
          method={method}
        />
      </FormProvider>


    </section>
  )
}